(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/casino-game/assets/javascript/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/casino/casino-game/assets/javascript/helpers/handlebars-helpers.js'); 'use strict';

(function () {
  if (svs.isServer) {
    registerHelpers(require('hbs'), require('trinidad-core').core.config, require('underscore'));
  } else {
    registerHelpers(Handlebars, {
      options: svs.core.config.data.svsconfig
    }, _);
  }

  function registerHelpers(hbs) {
    var _this = this;

    hbs.registerHelper('formatJackpot', function (amount, fromAmount) {
      if (!fromAmount || fromAmount > amount || amount - fromAmount >= 100000) {
        fromAmount = amount;
      }

      var fromDigits = "".concat(fromAmount).split('').reverse(),
          toDigits = "".concat(amount).split('').reverse();
      var numAnimatedDigits,
          counterHtml = '',
          staticHtml = '';

      for (var i = 0; i < toDigits.length; i++) {
        if (fromDigits[i] !== toDigits[i]) {
          numAnimatedDigits = i + 1;
        }
      }

      var firstAnimatedSteps = toDigits[numAnimatedDigits - 1] - fromDigits[numAnimatedDigits - 1];

      for (var _i = 0; _i < toDigits.length; _i++) {
        var pad = _i % 3 === 0,
            firstAnimated = _i + 1 === numAnimatedDigits,
            digit = Number(toDigits[_i]);

        if (_i < numAnimatedDigits) {
          var counterDigits = '';
          var numDigits = firstAnimated ? firstAnimatedSteps : 10;

          for (var j = numDigits; j >= 0; j--) {
            counterDigits += "".concat((10 + digit - j) % 10, " ");
          }

          var count = firstAnimated ? 1 : 1.5 * (numAnimatedDigits - (_i + 1)),
              dur = 2.0 / count;
          counterHtml = "<div class=\"jackpot-counter jackpot-digits".concat(pad ? ' decimal-group' : '', "\" style=\"animation-iteration-count: ").concat(count, ";animation-duration: ").concat(dur, "s\">").concat(counterDigits, "</div>").concat(counterHtml);
        } else {
          staticHtml = digit + (pad ? '&nbsp;' : '') + staticHtml;
        }
      }

      return "<div class=\"jackpot-digits\">".concat(staticHtml, "</div>").concat(counterHtml);
    });
    hbs.registerHelper('getRouletteColor', function (number) {
      return {
        '00': 'green',
        0: 'green',
        1: 'red',
        2: 'black',
        3: 'red',
        4: 'black',
        5: 'red',
        6: 'black',
        7: 'red',
        8: 'black',
        9: 'red',
        10: 'black',
        11: 'black',
        12: 'red',
        13: 'black',
        14: 'red',
        15: 'black',
        16: 'red',
        17: 'black',
        18: 'red',
        19: 'red',
        20: 'black',
        21: 'red',
        22: 'black',
        23: 'red',
        24: 'black',
        25: 'red',
        26: 'black',
        27: 'red',
        28: 'black',
        29: 'black',
        30: 'red',
        31: 'black',
        32: 'red',
        33: 'black',
        34: 'red',
        35: 'black',
        36: 'red'
      }[number];
    });
    hbs.registerHelper('getSeatsLeft', function (gameData) {
      return gameData.seatsTaken && gameData.seats - gameData.seatsTaken.length;
    });
    hbs.registerHelper('hasSeatsLeft', function (gameData, options) {
      if (gameData.seatsTaken && gameData.seats && gameData.seats - gameData.seatsTaken.length > 0) {
        return options.fn(_this);
      }

      return options.inverse(_this);
    }); 

    hbs.registerHelper('multiply', function (x, y) {
      return x * y;
    });
  }
})();
 })(window);